// SelectAddressDropdown helper functions and data

export const mobileBackdropConfig = {
  opacity: 0.25,
  color: "hsla(0, 0%, 0%, 1)"
};
